import React from 'react'
import { Box } from 'theme-ui'

export const EmphasedText = ({ children }) => (
  <Box sx={{ fontWeight: 'bold', pl: '5px', pr: '5px' }}>{children}</Box>
)
